import styled from "styled-components";

export const UserWrapper = styled.div`
  margin: 30px 0 50px;
`;
export const UserMainContentWrapper = styled.div`
  margin: 180px 0 50px 20px;
  z-index: 1;
  width: 100%;
  @media (max-width: 991.98px) {
    margin: 30px 0;
  }
`;
